import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.js";
import "./utils/i18n.js";
import "./index.css";
import "@fontsource-variable/public-sans";
import QueryProvider from "./providers/query.js";
import TRPCProvider from "./providers/trpc.js";
import { getCanvasIsolatedCssUrl } from "./utils/canvas.js";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
});

// Load canvas-isolated.css globally so non-shadow-DOM content (e.g. quiz text) can opt into
// the same paragraph/heading/list styling via the `_isolated-root` class.
const isolatedCssLink = document.createElement("link");
isolatedCssLink.rel = "stylesheet";
isolatedCssLink.href = getCanvasIsolatedCssUrl();
document.head.appendChild(isolatedCssLink);

const root = createRoot(document.getElementById("root") as HTMLElement);

const sessionToken = sessionStorage.getItem("sessionToken");
const win = window as typeof window & { sessionToken?: string };
if (win.sessionToken && win.sessionToken !== "{{ sessionToken }}" && sessionToken != win.sessionToken) {
  sessionStorage.setItem("sessionToken", win.sessionToken);
}

root.render(
  <StrictMode>
    <QueryProvider>
      <TRPCProvider>
        <App />
      </TRPCProvider>
    </QueryProvider>
  </StrictMode>,
);
